import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/home_title.png'
import _imports_1 from '../assets/img/map.jpg'
import _imports_2 from '../assets/img/home_desc.png'
import _imports_3 from '../assets/img/home_btn.png'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"title\"><img src=\"" + _imports_0 + "\" alt=\"\"></div><div class=\"map\"><img class=\"map-img\" src=\"" + _imports_1 + "\" alt=\"\"><div class=\"desc\"><img src=\"" + _imports_2 + "\" alt=\"\"></div></div>", 2)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page-home page-container", [_ctx.isLoaded && 'is-loaded']])
  }, [
    _hoisted_1,
    _createElementVNode("div", {
      class: "btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goPuzzle && _ctx.goPuzzle(...args)))
    }, _hoisted_4)
  ], 2))
}